var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#FFD241"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    fill: "#FF9F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6768 10.5213L13.679 10.0651L12.3389 7.22008C12.3023 7.14219 12.2421 7.07913 12.1677 7.04081C11.9811 6.94437 11.7544 7.02473 11.6612 7.22008L10.3211 10.0651L7.32326 10.5213C7.24061 10.5336 7.16504 10.5745 7.10719 10.6363C7.03725 10.7116 6.9987 10.8128 7.00003 10.9179C7.00136 11.0229 7.04245 11.123 7.11427 11.1964L9.28323 13.4108L8.7708 16.5376C8.75878 16.6104 8.76647 16.6852 8.79299 16.7536C8.81951 16.822 8.86379 16.8812 8.92083 16.9246C8.97787 16.968 9.04537 16.9937 9.11568 16.999C9.186 17.0042 9.25631 16.9888 9.31865 16.9543L12 15.478L14.6814 16.9543C14.7546 16.9951 14.8396 17.0087 14.9211 16.9939C15.1265 16.9568 15.2647 16.7528 15.2292 16.5376L14.7168 13.4108L16.8858 11.1964C16.9448 11.1358 16.9838 11.0566 16.9956 10.9701C17.0275 10.7537 16.8834 10.5534 16.6768 10.5213Z",
    fill: "#FFD241"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarImg);
export default __webpack_public_path__ + "static/media/dollar-img.a316a8c0c46300968acc091c40decae4.svg";
export { ForwardRef as ReactComponent };